<template>

<div class="carousel slide shadow-sm" data-ride="carousel" id="bs-carousel">
  <div class="carousel-inner" >
    <div class="carousel-item "  v-for="(value, title) in $page.props.global_config.banner" :key="title.index" :class="{'active':title=='banner_1'}">
      <img class="d-block w-100" :src="value" :alt="title">
    </div>
  </div>
  <a class="carousel-control-prev" href="#bs-carousel" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#bs-carousel" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>

</template>